/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import dynamic from 'next/dynamic';
import Skeleton from 'react-loading-skeleton';
import { isCNLocale } from '@marriott/shared/mi-helper-utils';

const BaiduMapContainer = dynamic(
  () => import('../BaiduMapContainer/BaiduMapContainer').then(mod => mod.BaiduMapContainer),
  {
    loading: () => <Skeleton containerTestId="baidu-map-skeleton" height="100%" enableAnimation />,
  }
);

const GoogleMapComponent = dynamic(() => import('../GoogleMapComponent').then(mod => mod.GoogleMapComponent), {
  loading: () => <Skeleton containerTestId="google-map-skeleton" height="100%" enableAnimation />,
});

interface MapComponentProps {
  currentLocale?: string;
  [key: string]: any;
}

export const MapComponent: FC<MapComponentProps> = ({ currentLocale = '', ...props }) => {
  if (isCNLocale(currentLocale)) {
    return <BaiduMapContainer {...props} />;
  }
  return <GoogleMapComponent {...props} />;
};
